import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: () => import('@/views/dashboard/index'),
      meta: { title: '首页', icon: 'el-icon-s-promotion' }
    }]
  },
  // {
  //   path: '/NewUserRanking',
  //   component: Layout,
  //   children: [{
  //     path: 'index',
  //     name: 'NewUserRanking',
  //     component: () => import('@/views/NewUserRanking/index'),
  //     meta: { title: '邀请排行榜', icon: 'el-icon-s-custom' }
  //   }]
  // },
  // {
  //   path: '/clubRanking',
  //   component: Layout,
  //   children: [{
  //     path: 'index',
  //     name: 'ClubRanking',
  //     component: () => import('@/views/clubRanking/index'),
  //     meta: { title: '社团排行榜', icon: 'el-icon-s-order' }
  //   }]
  // },
  {
    path: '/invitation',
    component: Layout,
    children: [{
      path: 'index',
      name: 'Invitation',
      component: () => import('@/views/invitation/index'),
      meta: { title: '邀请用户列表', icon: 'el-icon-s-custom' }
    }]
  },
  {
    path: '/goddess',
    component: Layout,
    children: [{
      path: 'index',
      name: 'Goddess',
      component: () => import('@/views/goddess/index'),
      meta: { title: '邀请女神列表', icon: 'el-icon-s-custom' }
    }]
  },
  {
    path: '/goddess-ranking',
    component: Layout,
    children: [{
      path: 'index',
      name: 'GoddessRanking',
      component: () => import('@/views/goddess-ranking/index'),
      meta: { title: '女神详情', icon: 'el-icon-s-data' }
    }]
  },
  {
    path: '/coin-recharge',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'CoinRecharge',
        component: () => import('@/views/coin-recharge/index'),
        meta: { title: '金币充值记录', icon: 'el-icon-s-finance' }
      }
    ]
  },

  {
    path: '/member-recharge',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'MemberRecharge',
        component: () => import('@/views/member-recharge/index'),
        meta: { title: '会员充值记录', icon: 'el-icon-user' }
      }
    ]
  },

  {
    path: '/withdrawal',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'Withdrawal',
        component: () => import('@/views/withdrawal/index'),
        meta: { title: '个人提现记录', icon: 'el-icon-s-finance' }
      }
    ]
  },

  // {
  //   path: '/bank-card',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'BankCard',
  //       component: () => import('@/views/bank-card/index'),
  //       meta: { title: '银行卡绑定', icon: 'el-icon-bank-card' }
  //     }
  //   ]
  // },

  {
    path: '/form',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'Form',
        component: () => import('@/views/form/index'),
        meta: { title: '个人信息', icon: 'el-icon-s-custom' }
      }
    ]
  },
  {
    path: '/score-detail',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'ScoreDetail',
        component: () => import('@/views/score-detail/index'),
        meta: { title: '积分明细', icon: 'el-icon-s-order' }
      }
    ]
  },

  // 推广合伙人：我的下级（meta.agent=true，非合伙人在侧边栏隐藏且路由守卫拦截）
  {
    path: '/agent',
    component: Layout,
    children: [
      {
        path: 'index',
        name: 'AgentSubordinate',
        component: () => import('@/views/agent/index'),
        meta: { title: '我的下级', icon: 'el-icon-s-cooperation', agent: true }
      }
    ]
  },






  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
